var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOverallExp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2H9.667v-.667A1.335 1.335 0 0 0 8.334 0H5.667a1.335 1.335 0 0 0-1.333 1.333V2H2A1.668 1.668 0 0 0 .333 3.667v6.666A1.668 1.668 0 0 0 2 12h10a1.669 1.669 0 0 0 1.667-1.667V3.667A1.668 1.668 0 0 0 12 2zm-7-.667a.667.667 0 0 1 .667-.666h2.667A.667.667 0 0 1 9 1.333V2H5v-.667zm8 9a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V6.018l3.895 1.299A.34.34 0 0 0 5 7.333h4a.34.34 0 0 0 .105-.016L13 6.018v4.315zm0-4.996a.327.327 0 0 0-.105.014L8.946 6.667H5.054L1.105 5.35A.327.327 0 0 0 1 5.337v-1.67a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v1.67z",
    fill: "#000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverallExp);
export default __webpack_public_path__ + "static/media/overall-exp.574cfa0968635fa97ba8965aa9aee601.svg";
export { ForwardRef as ReactComponent };